import { Button, ErrorState } from "@vellum/ui";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return error.message;
  return "Unknown error";
}

/** Shown in place of a route that threw while rendering or loading. */
export function RouteErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <ErrorState
      details={describe(error)}
      actions={
        <>
          <Button onClick={() => window.location.reload()}>Reload page</Button>
          <Link
            to="/"
            className="text-sm font-medium text-blue-500 no-underline hover:underline"
          >
            Back to Admin
          </Link>
        </>
      }
    />
  );
}
